import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CargomaticModal from 'components/v2/modal';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import PDFViewer from '../../shipments/PDFViewer';
import RotateIcon from '../../../v2/icons/RotateIcon';
import XIcon from '../../../v2/icons/XIcon';
import ImageViewer from '../../shipments/ImageViewer';

export function DocumentPreviewModal({ document, onClose, dialogClassName }) {
  const { t } = useTranslation();
  const [signUrl, setSignUrl] = useState(null);
  const [rotation, setRotation] = useState(0);

  const initDocumentPreview = async () => {
    setRotation(0);

    if (document?.signedUrl) {
      setSignUrl(document.signedUrl);
    } else {
      setSignUrl(null);
    }
  };

  useEffect(() => {
    initDocumentPreview();
  }, [document]);

  const handleRotation = () => {
    setRotation(rotation + 90);
  };

  const renderDocumentTypeViewer = (document) => {
    const { contentType } = document || {};
    const supportedImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];

    if (contentType === 'application/pdf') {
      return (
        <PDFViewer
          pdfStyle={{ transform: `rotate(${rotation}deg)` }}
          file={signUrl}
          height="auto"
          width="auto"
        />
      );
    }
    if (supportedImageTypes.includes(contentType)) {
      return (
        <ImageViewer
          alt="document preview"
          className="w-full h-full"
          fileUrl={signUrl}
          style={{ transform: `rotate(${rotation}deg)` }}
        />
      );
    }
    return (
      <span data-testid="span-8758d0c2">{t('DOCUMENT_NOT_SUPPORTED')}</span>
    );
  };

  function getBody() {
    return (
      <div className="block" data-testid="pod-preview-modal">
        <div data-testid="div-b1d5d5ca" className="min-h-[70vh] flex flex-col">
          {signUrl && (
            <div
              data-testid="div-9f04a2a9"
              className="flex-grow flex flex-col items-center"
            >
              {renderDocumentTypeViewer(document)}
            </div>
          )}
        </div>
      </div>
    );
  }

  function renderTitleBar() {
    return (
      <div
        data-testid="div-d8e31cb4"
        className="flex justify-between items-center"
      >
        <div
          data-testid="div-f3572605"
          className="modal-title-bar flex-grow flex"
        >
          <div
            data-testid="div-158c6778"
            className="modal-title-bar-text flex items-center flex-grow"
          >
            <div data-testid="div-c2ace0c0" className="flex-grow">
              {document &&
                document.createdAt &&
                moment(document.createdAt).format('M/D/YYYY h:mm a')}
            </div>
            <button
              data-testid="button-a90eb2cf"
              onClick={handleRotation}
              className="mr-4"
              aria-label="rotation button"
            >
              <RotateIcon size="large" className="w-6 h-6" />
            </button>
            <button
              data-testid="button-26a8a948"
              onClick={onClose}
              aria-label="close button"
            >
              <XIcon className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <CargomaticModal
      dataTestId="CargomaticModal-5b3d57e9"
      title={renderTitleBar()}
      dialogClassName={dialogClassName}
      style={{ top: '10%' }}
      size="large"
      backdrop={false}
      showCloseButton={false}
      show={!!document}
      onHide={onClose}
      body={getBody()}
    />
  );
}

DocumentPreviewModal.propTypes = {
  document: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  dialogClassName: PropTypes.func,
};
